import * as React from "react";
const PhotoPaidIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    viewBox="0 0 25 25"
    {...props}
  >
    <path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#242426",
        fillOpacity: 1,
      }}
      d="M20 20.594H5a2 2 0 0 1-2-2V8.625a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2v9.969a2 2 0 0 1-2 2Zm0 0"
    />
    <path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#242426",
        fillOpacity: 1,
      }}
      d="M17.172 7.676H7.828l2.5-3.27h4.344Zm0 0"
    />
    <path
      style={{
        fillRule: "nonzero",
        fill: "#fff",
        fillOpacity: 1,
        strokeWidth: 3,
        strokeLinecap: "butt",
        strokeLinejoin: "round",
        stroke: "#242426",
        strokeOpacity: 1,
        strokeMiterlimit: 10,
      }}
      d="M48.094 38.727a9.372 9.372 0 0 1-9.375 9.375c-5.172 0-9.367-4.196-9.367-9.375 0-5.172 4.195-9.368 9.367-9.368 5.18 0 9.375 4.196 9.375 9.368Zm0 0"
      transform="scale(.5)"
    />
    <path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#242426",
        fillOpacity: 1,
      }}
      d="M17.57 21.203c.176-.101.309-.2.399-.281a.857.857 0 0 0 .207-.32c.05-.133.07-.301.07-.508 0-.184-.012-.324-.031-.414h-.63v-.899h.524l-.054-.23a6.719 6.719 0 0 1-.106-.531 2.948 2.948 0 0 1-.05-.48c0-.505.14-.88.421-1.126.282-.242.68-.363 1.2-.363.535 0 .921.16 1.16.48.234.32.355.785.355 1.395h-1.238c0-.246-.016-.426-.043-.551-.024-.121-.094-.184-.203-.184-.074 0-.13.02-.16.063a.367.367 0 0 0-.055.187 2.39 2.39 0 0 0-.012.239v.05c0 .133.074.48.227 1.043h1.097v.903h-.964l.043.52a1.144 1.144 0 0 1-.172.577c-.102.168-.23.297-.38.391H21v1.133h-3.426v-1.094Zm0 0"
    />
    <path
      style={{
        fill: "none",
        strokeWidth: 3,
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        stroke: "#fff",
        strokeOpacity: 1,
        strokeMiterlimit: 10,
      }}
      d="M30.93 27.117a5.927 5.927 0 0 1-5.93 5.93 5.927 5.927 0 0 1-5.93-5.93 5.932 5.932 0 0 1 5.93-5.93 5.932 5.932 0 0 1 5.93 5.93Zm0 0"
      transform="scale(.5)"
    />
    <path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fff",
        fillOpacity: 1,
      }}
      d="M19.953 9.29a.972.972 0 0 1-.969.972.972.972 0 0 1 0-1.942.97.97 0 0 1 .97.97Zm0 0"
    />
  </svg>
);
export default PhotoPaidIcon;
